// src/routes/domains/uk/index.ts
import { ukRoutes } from './uk.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for UK routes.
 * Enables code splitting: the UK routes chunk will only load when needed.
 *
 * @returns A promise resolving to the UK routes array.
 */
export const loadUkRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(ukRoutes);
};